import React, { Component } from "react";
import axios from "axios";

import Operations from "../../components/Operations/Operations";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  CardImg,
  Button,
  ListGroup,
  ListGroupItem,
  Container,
} from "shards-react";
import { Modal } from "react-bootstrap";

export default class Student extends Component {
  constructor() {
    super();
    this.state = {
      _id: null,
      firstName: "",
      lastName: "",
      studyNumber: "",
      phone: "",
      city: "",
      school: "",
      cardPhotos: [],
      operations: [],
      dataFetched: false,
      cardBackPath: "",
      cardFrontPath: "",
      date_created: "",
      isVerified: false,
      popupOpen: false,
      popupToShow: "",
      disableVerifyBtn: false,
    };
  }

  componentDidMount = () => {
    const { href } = window.location;
    const studentId = href.substring(href.lastIndexOf("/") + 1);
    this.setState({ _id: studentId }, () => this.getStudent());
  };

  handleClose = () => {
    this.setState({
      popupOpen: false,
    });
  };
  handleShowVerify = () => {
    this.setState({
      popupOpen: true,
      popupToShow: "verify",
    });
  };

  handleShowPhoto = (index, path) => {
    index === 1
      ? this.setState({
          popupOpen: true,
          popupToShow: "front",
          cardFrontPath: path,
        })
      : this.setState({
          popupOpen: true,
          popupToShow: "back",
          cardBackPath: path,
        });
  };

  verifyStudent = () => {
    const id = this.state._id;

    if (id.length === 24) {
      this.setState({
        disableVerifyBtn: true,
      });
      axios
        .post(`${process.env.REACT_APP_API_URL}/admin/students/verify`, null, {
          withCredentials: true,
          params: {
            id,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              disableVerifyBtn: false,
              isVerified: true,
            });
            this.handleClose();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.setState({
            disableVerifyBtn: false,
          });
        });
    } else {
      console.log("the length is more than 24");
    }
  };

  getStudent = () => {
    const studentId = this.state._id;
    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/students/${studentId}`, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            isVerified: response.data.student.verified,
            dataFetched: true,
            ...response.data.student,
          });
        }
      })
      .catch((error) => {
        console.log("This is the error: " + error.response);
      });
  };
  render() {
    const {
      cardPhotos,
      firstName,
      lastName,
      studyNumber,
      phone,
      city,
      school,
      isVerified,
      cardBackPath,
      cardFrontPath,
      date_created,
      popupOpen,
      popupToShow,
      operations,
      dataFetched,
      disableVerifyBtn,
    } = this.state;

    const { admin } = this.props;

    return (
      <Container className="mt-5">
        <Card small className="mb-4 pt-3 ">
          <CardHeader className="border-bottom text-center ">
            <div className="mb-3 mr-0 text-left">
              <Button
                pill
                onClick={() => {
                  window.history.back();
                }}
              >
                &larr; Go Back
              </Button>
            </div>
            <h4 className="mb-0">
              {firstName} {lastName}
            </h4>
            <span className="text-muted d-block mb-2">
              {date_created.substr(0, 10)}
            </span>
            <ListGroup
              flush
              className="d-inline-flex flex-wrap flex-row justify-content-center "
            >
              <ListGroupItem className="p-4 ">
                <strong className="text-muted d-block mb-2">ville</strong>
                <span>{city}</span>
              </ListGroupItem>
              <ListGroupItem className="p-4">
                <strong className="text-muted d-block mb-2">Telephone</strong>
                <span>{phone}</span>
              </ListGroupItem>
              <ListGroupItem className="p-4">
                <strong className="text-muted d-block mb-2">Num apogée</strong>
                <span>{studyNumber}</span>
              </ListGroupItem>
              <ListGroupItem className="p-4">
                <strong className="text-muted d-block mb-2">Ecole</strong>
                <span>{school}</span>
              </ListGroupItem>
              <ListGroupItem className="p-4">
                <strong className="text-muted d-block mb-2">
                  Pièce d'identité
                </strong>
                {cardPhotos.map((photo, index) => (
                  <Button
                    key={index}
                    className="ml-1"
                    onClick={() => this.handleShowPhoto(index + 1, photo.path)}
                  >
                    {index + 1}
                  </Button>
                ))}
                <Modal show={popupOpen} onHide={this.handleClose}>
                  {popupToShow === "verify" ? (
                    <div>
                      <Modal.Header closeButton>
                        <Modal.Title>Êtes-vous sûr</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>Continuer à vérifier cet élève?</Modal.Body>
                      <Modal.Footer>
                        <Button
                          theme="success"
                          pill
                          onClick={this.verifyStudent}
                          disabled={disableVerifyBtn}
                        >
                          &#10003; Verifier
                        </Button>
                        <Button theme="danger" pill onClick={this.handleClose}>
                          &#10003; Annuler
                        </Button>
                      </Modal.Footer>
                    </div>
                  ) : popupToShow === "front" ? (
                    <div>
                      <Modal.Header closeButton>
                        <Modal.Title>Carte d'étudiant avant</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Card>
                          <CardImg
                            src={`${process.env.REACT_APP_API_URL}/admin/userphoto?path=${cardFrontPath}`}
                            alt="Carte d'étudiant avant"
                          />
                        </Card>
                      </Modal.Body>
                    </div>
                  ) : (
                    <div>
                      <Modal.Header closeButton>
                        <Modal.Title>Carte d'étudiant derrière</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Card>
                          <CardImg
                            src={`${process.env.REACT_APP_API_URL}/admin/userphoto?path=${cardBackPath}`}
                            alt="Carte d'étudiant deriere"
                          />
                        </Card>
                      </Modal.Body>
                    </div>
                  )}
                </Modal>
              </ListGroupItem>
              <ListGroupItem className="p-4 text-center mt-4 mb-4">
                <Button
                  theme="success"
                  pill
                  onClick={this.handleShowVerify}
                  disabled={isVerified}
                >
                  &#10003; {isVerified ? "Déjà Vérifié" : "Vérifier"}
                </Button>
              </ListGroupItem>
            </ListGroup>
          </CardHeader>
          <CardBody className="text-center m-3">
            <Row className="mt-4">
              {dataFetched ? (
                <Operations
                  admin={admin}
                  operations={operations}
                  isVerified={isVerified}
                />
              ) : (
                ""
              )}
            </Row>
          </CardBody>
        </Card>
      </Container>
    );
  }
}
